import Form from 'mobx-react-form';
import { muiFormBindings } from 'forms/utils/muiFormBindings';
import { plugins } from 'forms/utils/formPlugins';
import { FieldsDefinitions } from 'mobx-react-form/lib/models/FormInterface';
import { passwordReset } from 'utils/labels';
import { formOptions } from 'forms/utils/formOptions';
import { isEmail, isRequired } from 'forms/utils/validators';

const fields: FieldsDefinitions = [
  {
    name: 'email',
    label: passwordReset.email,
    bindings: 'TextField',
    value: '',
    validators: [isRequired, isEmail],
  },
];

export function createForm() {
  return new Form({ fields }, { plugins, bindings: muiFormBindings, options: formOptions });
}
